var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4798 0C21.197 0 24 3.06533 24 7.13026V14.8788C24 16.9592 23.2722 18.8388 21.9494 20.1723C20.7628 21.3671 19.2234 22 17.4977 22H6.49898C4.77656 22 3.23833 21.3682 2.0506 20.1723C0.727814 18.8388 0 16.9592 0 14.8788V7.13026C0 3.06533 2.80298 0 6.52019 0H17.4798ZM17.4798 1.69231H6.52019C3.71274 1.69231 1.67442 3.97918 1.67442 7.13026V14.8788C1.67442 16.5068 2.22809 17.961 3.23274 18.973C4.09898 19.8474 5.22977 20.3077 6.50233 20.3077H17.4798C17.482 20.3054 17.491 20.3077 17.4977 20.3077C18.7714 20.3077 19.901 19.8474 20.7673 18.973C21.773 17.961 22.3256 16.5068 22.3256 14.8788V7.13026C22.3256 3.97918 20.2873 1.69231 17.4798 1.69231ZM19.2391 6.91454C19.5304 7.2767 19.4757 7.80921 19.1174 8.1048L14.1567 12.1799C13.5293 12.6831 12.7792 12.9346 12.0301 12.9346C11.2833 12.9346 10.5388 12.6853 9.91591 12.1866L4.9094 8.10706C4.54884 7.81372 4.49302 7.28008 4.78214 6.9168C5.07349 6.55465 5.60037 6.49711 5.95981 6.78931L10.9619 10.8644C11.5903 11.3676 12.4755 11.3676 13.1085 10.8599L18.0603 6.79157C18.4197 6.49485 18.9466 6.55126 19.2391 6.91454Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInput);
export default __webpack_public_path__ + "static/media/emailInput.ff26cf733b5ecde2b66cd013ef4ca39b.svg";
export { ForwardRef as ReactComponent };